module.exports = __webpack_public_path__ + "media/images/map_marker-e0e98f12.svg";